import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from './ui/dialog';
import { Button } from './ui/button';
import { UserPlus, LogIn } from 'lucide-react';

/**
 * Modal shown when a guest user tries to perform a restricted action.
 * Prompts them to sign up or sign in to continue.
 */
const GuestActionModal = ({ open, onOpenChange }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleSignUp = () => {
    onOpenChange(false);
    navigate('/register');
  };

  const handleSignIn = () => {
    onOpenChange(false);
    navigate('/login');
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md" data-testid="guest-action-modal">
        <DialogHeader>
          <DialogTitle className="text-xl">
            {t('guest.modalTitle', 'Create an account to start planning')}
          </DialogTitle>
          <DialogDescription className="text-base pt-2">
            {t('guest.modalBody', 'Sign up to unlock this feature. Get 5 free credits when you create your account!')}
          </DialogDescription>
        </DialogHeader>
        <div className="flex flex-col sm:flex-row gap-3 pt-4">
          <Button 
            onClick={handleSignUp}
            className="flex-1 rounded-full"
            data-testid="guest-modal-signup-btn"
          >
            <UserPlus className="h-4 w-4 mr-2" />
            {t('auth.signUp', 'Sign Up — Get 5 Free Credits')}
          </Button>
          <Button 
            variant="outline"
            onClick={handleSignIn}
            className="flex-1 rounded-full"
            data-testid="guest-modal-signin-btn"
          >
            <LogIn className="h-4 w-4 mr-2" />
            {t('auth.signIn', 'Sign In')}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default GuestActionModal;
